import React,{Fragment, useState, useEffect} from 'react';
import moment from "moment";
import { _CFG } from '../../../../modules/config';
import ArrowSelectIcon from '../../../../resources/common/arrow_select.svg';

export default (props) => { 
  const { info, siteInfo, passCodeOpt, passcodeNext, isPasswordVisible,
    passCodePrivacyOpen, passCodeUseOpen, passCodeOverseaOpen, onLoginClick, onSetInfo,
    preregEventList, setIsPasswordVisible, goEventSessionList, goMypage, passCodeShowTerms, setPassCodeUseAgree, setPassCodePrivacyAgree, setPassCodeOverseaAgree, passCodePrivacyAgree, passCodeUseAgree, passCodeOverseaAgree, setPassCodePrivacyOpen, setPassCodeUseOpen, setPassCodeOverseaOpen, loginError, setLoginError, loginPartiYn, onSwitchToParticipation } = props;

  const [allChecked, setAllChecked] = useState(false);

  const termsCount = [passCodePrivacyOpen, passCodeUseOpen, passCodeOverseaOpen].filter(Boolean).length;

  const handleAllCheckedChange = (value) => {
    setAllChecked(value);
    setPassCodePrivacyAgree(value);
    setPassCodeUseAgree(value);
    setPassCodeOverseaAgree(value);
  };

  useEffect(() => {

    const allCheckedState =
      (passCodePrivacyOpen ? passCodePrivacyAgree : true) &&
      (passCodeUseOpen ? passCodeUseAgree : true) &&
      (passCodeOverseaOpen ? passCodeOverseaAgree : true) &&
      (passCodePrivacyOpen || passCodeUseOpen || passCodeOverseaOpen);

    setAllChecked(allCheckedState);
  }, [passCodePrivacyAgree, passCodeUseAgree, passCodeOverseaAgree]);

  return (
    <div className="login_box psc_box">
      {!passcodeNext && (
        <div className="psc_box1">
          {loginPartiYn === "Y" && (
            <div style={{ textAlign: "right", marginBottom: "8px" }}>
              <a
                onClick={onSwitchToParticipation}
                style={{ cursor: "pointer", fontSize: "13px", color: "#7b5cff", textDecoration: "underline", whiteSpace: "nowrap" }}
              >
                {siteInfo?.idx == 125 ? "Login with access code" : "참가고유코드 로그인"}
              </a>
            </div>
          )}
          {passCodeOpt[0]?.topPhraseFormUse !== 'N' ? (
            <div dangerouslySetInnerHTML={{__html: passCodeOpt[0]?.topPhraseForm}}/>
          ) : ''}
          <div className="login_input_div">
            <input
              className="login_input"
              id="psc_password"
              type={!isPasswordVisible ? "password" : "text"}
              placeholder= {siteInfo?.idx != 125 ? "패스코드를 입력해 주세요." : 'Please enter the passcode.'}
              defaultValue=""
              onChange={(e) => {
                // ✅ 사용자가 입력하면 에러 메시지 & 약관 UI 초기화
                if (loginError) {
                  setLoginError(null);
                }
                // ✅ 약관 동의 체크박스 초기화
                if (passCodePrivacyOpen || passCodeUseOpen || passCodeOverseaOpen) {
                  setPassCodePrivacyOpen(false);
                  setPassCodeUseOpen(false);
                  setPassCodeOverseaOpen(false);
                  setPassCodePrivacyAgree(false);
                  setPassCodeUseAgree(false);
                  setPassCodeOverseaAgree(false);
                }
              }}
              onKeyPress={(e) => {
                if (e.key == "Enter"){
                  onLoginClick(e);
                } 
              }}
              style={loginError ? { borderColor: '#ff4444' } : undefined}
            />
              <img
                src="https://cdn.onoffevent.com/login/icon-s-password.svg"
                onClick={(e)=>setIsPasswordVisible(!isPasswordVisible)}
                style={{opacity:`${isPasswordVisible == true? "0.5":"1"}`,cursor:"pointer"}}
              />
          </div>
          {loginError && (
            <div 
              className="login_error_message"
              style={{
                marginTop: '4px',
                marginBottom: '0px',
                color: '#DC2626',
                fontSize: '12px',
                lineHeight: '1.5',
                wordBreak: 'keep-all',
                whiteSpace: 'pre-wrap'
              }} 
              dangerouslySetInnerHTML={{__html: loginError.replace(/<br>\s*/gi, ' ').replace(/\*문의:/g, '<br/>문의:')}} 
            />
          )}
          {(passCodePrivacyOpen == true || passCodeUseOpen == true || passCodeOverseaOpen == true) && (
            <div className="agree_form">
              <ul> 
                {termsCount >= 2 && (
                  <li>
                    <p>
                      <input
                        type="checkbox"
                        id="login_agree_all"
                        checked={allChecked}
                        onChange={(e) => handleAllCheckedChange(e.target.checked)}
                      />
                      <label id="chk_label" htmlFor="login_agree_all">
                        <span></span>
                        모두 동의합니다.
                      </label>
                    </p>
                  </li>
                )}
                {passCodePrivacyOpen == true && (
                  <li>
                    <p>
                      <input type="checkbox" id="login_agree_box2" onChange={(e) => setPassCodePrivacyAgree(e.target.checked)} checked={passCodePrivacyAgree}/>
                      <label id="chk_label" htmlFor="login_agree_box2" >
                        <span></span>
                        {`${passCodeOpt[0].termsPrivacyFormLabel} ${passCodeOpt[0]?.termsPrivacyFormEsUse == 'Y' ? '(필수)' : '(선택)'}`}
                      </label>
                    </p>
                    <a style={{ cursor: "pointer",whiteSpace:"nowrap" }} onClick={passCodeShowTerms.bind(this, "termsPrivateAgree")}>
                      내용보기
                    </a>
                  </li>
                )}
                {passCodeOverseaOpen == true && (
                  <li>
                    <p>
                      <input type="checkbox" id="login_agree_box3" onChange={(e) => setPassCodeOverseaAgree(e.target.checked)} checked={passCodeOverseaAgree}/>
                      <label id="chk_label" htmlFor="login_agree_box3">
                        <span></span>
                        {/* {passCodeOpt[0].termsOverseaLabel} */}
                        {`${passCodeOpt[0]?.termsOverseaLabel} ${passCodeOpt[0]?.termsOverseaEsUse == 'Y' ? '(필수)' : '(선택)'}`}
                        </label>
                    </p>
                    <a style={{ cursor: "pointer",whiteSpace:"nowrap"}} onClick={passCodeShowTerms.bind(this,"termsOverseaAgree")}>
                      내용보기
                    </a>
                  </li>
                )}
                {passCodeUseOpen == true && (
                  <li>
                    <p>
                      <input type="checkbox" id="login_agree_box" onChange={(e) => setPassCodeUseAgree(e.target.checked)} checked={passCodeUseAgree}/>
                      <label id="chk_label" htmlFor="login_agree_box">
                        <span></span>
                        {/* {passCodeOpt[0].termsUseFormLabel} */}
                        {`${passCodeOpt[0]?.termsUseFormLabel} ${passCodeOpt[0]?.termsUseFormEsUse == 'Y' ? '(필수)' : '(선택)'}`}
                      </label>
                    </p>
                    <a style={{ cursor: "pointer" }} onClick={passCodeShowTerms.bind(this,"termsUseAgree")}>
                      내용보기
                    </a>
                  </li>
                )}
              </ul>
            </div>
          )}
          <div className="login_enter">
            <span id="passcode_submit_btn" onClick={(e) => onLoginClick(e)}>
              {passCodeOpt[0] != null ? (passCodeOpt[0].loginBtnLabel != null && passCodeOpt[0].loginBtnLabel != "" ? passCodeOpt[0].loginBtnLabel : "심포지엄 확인하기") : "심포지엄 확인하기"}
            </span>
          </div>
        </div>
      )}
      {passcodeNext && (
        <>
        {preregEventList?.length > 0 && (
          <div
            className="psc_box2"
            style={{ display: "block" }}
          >
            <p>
              총 {preregEventList.length}개의 이벤트에 등록이
              되어있습니다.
              <br />
              선택하신 이벤트로 입장하실 수 있습니다.
            </p>
            {preregEventList?.map((item, i) => (
              <Fragment key={i}>
                <div
                  className="login_session psc_session"
                  onClick={(e) =>
                    goEventSessionList(item, e)
                  }
                >
                  <div className="psc_hd">
                    <h4 className="login_session_h4">
                      <a>{item.name}</a>
                    </h4>
                    <p>
                      <img
                        src={ArrowSelectIcon}
                        alt="펼쳐보기"
                      />
                    </p>
                  </div>
                  {(item?.startDate && item.endDate) ? (
                  <p className="login_session_p">
                    {moment(item?.startDate).format(
                      "YYYY.MM.DD(ddd) HH:mm"
                    )}{" "}
                    ~{" "}
                    {moment(item?.endDate).format(`
                      ${moment(item?.startDate).format('YYYY.MM.DD') == moment(item?.endDate).format('YYYY.MM.DD') ? 'HH:mm' : 'YYYY.MM.DD(ddd) HH:mm'}`
                    )}
                  </p>
                  )
                  : ""
                    }
                </div>
              </Fragment>
            ))}
          </div>
        )}

          {/* <a href="#" onClick={e => goMypage(e)}  style={{display:"block",textAlign:"right"}}>마이페이지</a> */}
        </>
      )}
      
    </div>
  )
}